// import React, { useEffect, useState } from "react";
// import TextSnippetIcon from "@mui/icons-material/TextSnippet";
// import { Link } from "react-router-dom";
// import withRouter from "../withRouter.js";
// import Footer from "../Component/Footer.js";
// import Menu from "../Component/Menu.js";
// import Header from "../Component/Header.js";
// import { screens } from "../Common/Products.js";
// import Credentials from "../Common/Credentials.js";
// import mastersIcom from "../images/Icons/generic.png"
// import tenantsIcom from "../images/Icons/user-account.png"
// import AccountsIcon from "../images/Icons/accounting.png"
// import dashboardIcon from "../images/Icons/dashboard.png"
// import "../NewUI/NewMenu.css";
// import Breadcrumb from "../NewUI/NewComponents/Breadcrumb.jsx";

// const SuperadminMenu = () => {
//   const [hovered, setHovered] = useState(null);

//   useEffect(() => {
//     Credentials.setSelectedMenu("Tenants")
//   }, [])

//   return (
//     <div>
//       <Header />
//       <Menu />

//       <section className="content-wrapper">
//         <div className="menu-container">
//           <div className="menu-card">
//             <div className="menu-header">
//               <Breadcrumb breadcrumbs={[{name:"Home",path:"/dashboard"},{name:"Super Admin Masters",path:null}]}/>


//               <div className="h-max border-slate-300 bg-white  p-4 rounded-lg menu-content">
//                 <ul className="menu-nav-list">
//                   <li className="menu-nav-item">
//                     <Link
//                       to={{ pathname: "/index" }}
//                       state={{ message: "" }}
//                       className="menu-nav-link"
//                     >
//                       <img className="menu-nav-icon" width="25" src={dashboardIcon} />
//                       <div className="mt-1">Dashboard</div>
//                     </Link>
//                   </li>
//                 </ul>

//                 <div className="menu-sections-container">
//                   <div className="menu-section">
//                     <span className="menu-section-title">
//                       <img className="menu-section-icon" width="25" src={tenantsIcom} />
//                       <span className="menu-section-title-text">Tenants</span>
//                     </span>
//                     <ul className="menu-items-list">
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{pathname: "/tenants"}}
//                           state={{ message: ""}}
//                         >
//                           Tenants
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{pathname: "/subscriptions"}}
//                           state={{ message: ""}}
//                         >
//                           Subscription Packs
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>

//                   <div className="menu-section">
//                     <span className="menu-section-title">
//                       <img className="menu-section-icon-masters" src={mastersIcom} />
//                       <span className="menu-section-title-text">Masters</span>
//                     </span>
//                     <ul className="menu-items-list">
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/screens" }}
//                           state={{ message: "" }}
//                         >
//                           Screens
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/products" }}
//                           state={{ message: "" }}
//                         >
//                           Products
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{pathname: "/prefixtypes"}}
//                           state={{ message: ""}}
//                         >
//                           Prefix Type
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/countries" }}
//                           state={{ message: "" }}
//                         >
//                           Countries
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/states" }}
//                           state={{ message: "" }}
//                         >
//                           States
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/cities" }}
//                           state={{ message: "" }}
//                         >
//                           Cities
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/hsn" }}
//                           state={{ message: "" }}
//                         >
//                           HSN
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>

//                   {screens.includes("Accounts Masters") ? (
//                     <div className="menu-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon" width="20" src={AccountsIcon} />
//                         <span className="menu-section-title-text">Accounts Masters</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/subacc" }}
//                             state={{ message: "" }}
//                           >
//                             Ledger Group
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   ) : ""}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default withRouter(SuperadminMenu);







import React from 'react';
import {
  FolderLock,
  ArrowRightLeft,
  FileText,
  ChevronRight,
  Blocks,
  Ruler,
  Tag,
  Palette,
  Layers,
  ShoppingBag,
  Wrench,
  DollarSign,
  Boxes,
  ClipboardCopy,
  AlertTriangle,
  FolderSync,
  TrendingDown,
  Warehouse,
  Users,
  Building2,
  Truck,
  Grid,
  Handshake,
  Calculator,
  ShieldUser,
  Database,
  ShieldCheck,
  Globe,
  EarthIcon,
  MapIcon,
  MapPinIcon,
  CalendarCheckIcon,
  LayoutDashboardIcon,
  CreditCardIcon,
  TableConfigIcon,
  ChartPieIcon,
  CogIcon
} from 'lucide-react';
import path from 'path-browserify';
import withRouter from '../withRouter';
import Footer from '../Component/Footer';
import { Backdrop } from '@mui/material';
import Header from '../Component/Header';
import Menu from '../Component/Menu';
import { theme, transactionFrom } from '../Common/Credentials';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from '../NewUI/NewComponents/Breadcrumb';
import { use } from 'react';
import Layout from '../Component/Layout';

const SuperadminMenu = () => {
  const navigate = useNavigate();
  // Structure mapping matching the image exactly
  const newsections = [
    {
      title: 'Tenants',
      subtitle: 'Multi-tenant client database shards',
      icon: FolderLock,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
      items: [
        { id: 'tenants', label: 'Tenants', desc: 'SaaS tenant subscription database locks', icon: Database, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-707', path: '/tenants', brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1' },
        { id: 'sub_packs', label: 'Subscription Packs', desc: 'Pricing plans, user gates limitations parameters', icon: ShieldCheck, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707', path: '/subscriptions', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' },
        { id: 'paymentsdashboard', label: 'Payments Dashboard', desc: 'Payment dashboard', icon: LayoutDashboardIcon, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707', path: '/paymentsdashboard', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' },
        { id: 'payments', label: 'Payments', desc: 'Payments Listing', icon: CreditCardIcon, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707', path: '/payments', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' },
        { id: 'gateways', label: 'Payment Gateways', desc: 'Payment Gateways master', icon: TableConfigIcon, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707', path: '/gateways', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' },
        { id: 'gateway-configurations', label: 'Payment Gateway Configurations', desc: 'Payment Gateways Configurations', icon: CogIcon, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707', path: '/gateway-configurations', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' },
        { id: 'subscriptions', label: 'Subscriptions', desc: 'Subscriptions', icon: CalendarCheckIcon, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707', path: '/subscriptionslist', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' },
        { id: 'revenue-reports', label: 'Revenue Reports', desc: 'Revenue Reports', icon: ChartPieIcon, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707', path: '/reports/revenue', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' }

      ]
    },
    {
      title: 'Masters',
      subtitle: 'System layout & locations parameters',
      icon: FolderLock,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
      items: [
        { id: 'screens', label: 'Screens Templates', desc: 'UI layout features registry configs', icon: Layers, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:tw-bg-blue-100 tw-text-blue-700', path: '/screens', brandColor: theme === "classic" ? '#4d4d4d' : '#3B82F6' },
        { id: 'products', label: 'Products', desc: 'Module management', icon: ShoppingBag, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-green-50 hover:tw-bg-green-100 tw-text-green-700', path: '/products', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' },
        { id: 'prefixtypes', label: 'Prefix Types', desc: 'Document numbering prefix parameters', icon: Ruler, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-yellow-50 hover:tw-bg-yellow-100 tw-text-yellow-700', path: '/prefixtypes', brandColor: theme === "classic" ? '#4d4d4d' : '#FBBF24' },
        { id: 'countries', label: 'Countries', desc: 'Country master for tenant onboarding', icon: EarthIcon, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-cyan-50 hover:tw-bg-cyan-100 tw-text-cyan-700', path: '/countries', brandColor: theme === "classic" ? '#4d4d4d' : '#06B6D4' },
        { id: 'states', label: 'States', desc: 'State master for tenant onboarding', icon: MapIcon, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-teal-50 hover:tw-bg-teal-100 tw-text-teal-700', path: '/states', brandColor: theme === "classic" ? '#4d4d4d' : '#14B8A6' },
        { id: 'cities', label: 'Cities', desc: 'City master for tenant onboarding', icon: MapPinIcon, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-emerald-50 hover:tw-bg-emerald-100 tw-text-emerald-700', path: '/cities', brandColor: theme === "classic" ? '#4d4d4d' : '#10B981' },
        { id: 'hsn_master', label: 'HSN Tax Classifications', desc: 'Govt HS / SAC tax groups parameters', icon: Tag, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-purple-50 hover:tw-bg-purple-100 tw-text-purple-700', path: '/hsn', brandColor: theme === "classic" ? '#4d4d4d' : '#7C3AED' }
      ]
    },
    {
      title: 'Accounts Masters',
      subtitle: 'Accounting groups and ledger configurations',
      icon: FolderLock,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
      items: [
        { id: 'subacc', label: 'Ledger Groups', desc: 'Accounting ledger group master', icon: Calculator, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-gray-50 hover:tw-bg-gray-100 tw-text-gray-700', path: '/subacc', brandColor: theme === "classic" ? '#4d4d4d' : '#374151' }
      ]
    }
  ]


  const onSelectItem = (path) => {
    navigate(path, { state: { message: "" } });
  }

  return (
    <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={transactionFrom === null}
      >
        <div className="menu-backdrop-content">
          <div className="d-flex justify-content-center">
            <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
          </div>
          <div className="d-flex justify-content-center">
            <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
          </div>
        </div>
      </Backdrop>

      <Layout menu={"superadminmasters"}>
        <div className="menu-container tw-mr-2 tw-ml-4">
          <div
            id="dashboard-content-area"
            className="tw-flex-1  tw-overflow-y-auto tw-bg-transparent tw-pb-4"
          >
            {/* Upper Hero Grid */}
            <div
              id="hero-welcome-banner"
              className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-items-center tw-bg-white tw-rounded-3xl tw-px-8 tw-py-2 tw-border tw-border-slate-200/80 tw-shadow-[0_12px_40px_rgba(0,0,0,0.02)] tw-mb-4 tw-relative tw-overflow-hidden"
            >
              {/* Background Blur Shapes */}
              <div className="tw-absolute tw-top-0 tw-right-0 tw-w-96 tw-h-96 tw-bg-blue-50/40 tw-rounded-full tw-blur-3xl -tw-z-10 tw-translate-x-12 -tw-translate-y-12"></div>

              <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-64 tw-h-64 tw-bg-indigo-50/30 tw-rounded-full tw-blur-3xl -tw-z-10 -tw-translate-x-12 tw-translate-y-12"></div>

              {/* Left Content */}
              <div className="md:tw-col-span-2 tw-text-left tw-space-y-2">
                <Breadcrumb breadcrumbs={[{ name: "Home", path: "/index" }, { name: "Masters", path: null }]} />
                <h1 className="tw-text-4xl tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-pt-1">
                  Super Admin Masters Management
                </h1>

                <p className="tw-text-slate-500 tw-font-medium tw-text-[10px] md:tw-text-xs tw-max-w-lg">
                  SaaS multi-tenant infrastructure. Lock tenant subscription databases schemas keys, restrict global UI screen modules templates, and configure tax laws parameters.
                </p>
              </div>

              {/* 3D SVG Security Badging Illustration */}
              <div className="tw-flex tw-justify-center md:tw-justify-end tw-mt-4 md:tw-mt-0 tw-relative tw-group">
                <div className="tw-w-32 tw-h-32 tw-relative tw-flex tw-items-center tw-justify-center ">
                  <div className="absolute bottom-4 w-28 h-3 bg-slate-300/30 rounded-full blur-md"></div>

                  <svg viewBox="0 0 200 200" className="w-32 h-32 drop-shadow-xl select-none pointer-events-none">
                    <defs>
                      <linearGradient id="srvGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#4F46E5" />
                        <stop offset="100%" stopColor="#312E81" />
                      </linearGradient>
                    </defs>
                    <ellipse cx="100" cy="155" rx="60" ry="10" fill="#1E293B" opacity="0.3" />
                    {/* Mainframe Case */}
                    <rect x="50" y="35" width="100" height="110" rx="14" fill="url(#srvGrad)" stroke="#6366F1" strokeWidth="2" />
                    {/* Server Slots rows */}
                    {/* Slot 1 */}
                    <rect x="62" y="50" width="76" height="16" rx="4" fill="#1E1B4B" />
                    <circle cx="72" cy="58" r="3" fill="#10B981" className="animate-pulse" />
                    <rect x="84" y="56" width="44" height="4" rx="2" fill="#4338CA" />
                    {/* Slot 2 */}
                    <rect x="62" y="75" width="76" height="16" rx="4" fill="#1E1B4B" />
                    <circle cx="72" cy="83" r="3" fill="#6366F1" className="animate-pulse" />
                    <rect x="84" y="81" width="44" height="4" rx="2" fill="#4338CA" />
                    {/* Slot 3 */}
                    <rect x="62" y="100" width="76" height="16" rx="4" fill="#1E1B4B" />
                    <circle cx="72" cy="108" r="3" fill="#EC4899" className="animate-pulse" />
                    <rect x="84" y="106" width="44" height="4" rx="2" fill="#4338CA" />
                    {/* Bottom Ventilation grid */}
                    <rect x="62" y="125" width="76" height="6" fill="#4338CA" rx="1" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Main Grid */}
            <div
              id="erp-columns-grid"
              className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4"
            >


              {/* Menus */}
              {newsections.map((section) => {
                // const Icon = section.icon;
                return (
                  <div
                    key={section.title}
                    id="section-col-masters"
                    className="tw-bg-white tw-rounded-3xl tw-border tw-border-slate-200/80 tw-p-6 tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)] tw-text-left tw-flex tw-flex-col hover:tw-shadow-lg tw-transition-shadow tw-duration-300"
                  >
                    <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6 tw-pb-4 tw-border-b tw-border-slate-100">
                      <div
                        className={`tw-w-12 tw-h-12 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-border ${section.iconColor}`}
                      >
                        <FolderLock size={22} />
                        {/* <Icon size={22} color={section.iconColor} /> */}
                      </div>

                      <div>
                        <h2 className="tw-text-lg tw-font-extrabold tw-text-slate-800">
                          {section.title}
                        </h2>

                        <p className="tw-text-xs tw-text-slate-400 tw-font-medium tw-my-0">
                          {section.subtitle}
                        </p>
                      </div>
                    </div>

                    <div className="tw-space-y-3 tw-flex-1">
                      {section.items.map((item) => {
                        const Icon = item.icon;

                        return (
                          <button
                            id={`subsection-btn-${item.id}`}
                            key={item.id}
                            onClick={() => onSelectItem(item.path)}
                            className="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white hover:tw-bg-slate-50 hover:tw-border-slate-300/60 hover:tw-shadow-sm tw-transition-all tw-group tw-duration-200 tw-cursor-pointer tw-text-left"
                          >
                            <div className="tw-flex tw-items-center tw-gap-3.5">
                              <div
                                className={`tw-w-9 tw-h-9 tw-rounded-xl tw-flex tw-items-center tw-justify-center ${item.brandStyle} tw-shrink-0`}
                              >
                                <Icon size={16} color={item.brandColor} />
                              </div>

                              <div>
                                <h4 className="tw-text-sm tw-font-bold tw-text-slate-700 group-hover:tw-text-blue-600 tw-transition-colors">
                                  {item.label}
                                </h4>

                                {/* <p className="tw-text-[10px] tw-text-slate-400 tw-font-medium tw-mt-0.5 tw-mb-0">
                    {item.desc}
                  </p> */}
                              </div>
                            </div>

                            <ChevronRight
                              size={16}
                              className="tw-text-slate-300 group-hover:tw-text-blue-500 group-hover:tw-translate-x-0.5 tw-transition-all"
                            />
                          </button>
                        );
                      })}
                    </div>
                  </div>)
              }
              )}
            </div>

          </div>
        </div>
      </Layout>
    </div>
  );
}
export default withRouter(SuperadminMenu);